  <div id="tempprofile">
    <div class="speaker-card py-4 mb-1 speaker-card" id="profile_show_hide">
      <div class="m-auto position-relative user-100 cursor-pointer " >
        <app-user-pofile-pic (profilePicClicked)="profilePicClicked()" [usedFor]="editorChoice" [profile_pic_image]="profile_left_pic_image" ></app-user-pofile-pic>
      </div>
        <p *ngIf="userProfile!=null "  class="mt-3 heading-4 text-center cursor-pointer"
          (click)="navigateToProfile()" >
          <span class="color-deep-green">
          {{userProfile?.first_name+' '+userProfile?.middle_name+' '+userProfile?.last_name}}</span></p>
        <p (click)="navigateToProfile()"  class="mt-1 text-center cursor-pointer secondary-paragraph" >
          <span class="color-grey-500">{{designation}}</span>
        </p>
    </div>
  </div>